<template lang="pug">
  .page
    section
      b-container
        h1 Password reset
        p Please complete the form below to reset your password
        b-form(v-on:submit.prevent='resetPassword()')
          .container
            b-form-group(label="EMAIL")
              b-form-input(type='email', v-model='inputForm.email', required='', placeholder='email', autocomplete="email")
            b-form-group(label="PASSWORD")
              b-form-input(type="password", name="password", v-model="inputForm.password", required="", pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
            p Password must be atleast 8 characters, with a number and a capital letter.
            b-form-group(label="REPEAT")
              b-form-input(type="password", name="password2", v-model="passwordRepeat", required="", pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
            button-load(type="SUBMIT", :flag="alert.busy", label="Submit", classes="btn-outline")

</template>

<script>
import standardMix from '@/mixins/standardMix';
import { userService } from '@/services';
import router from '@/router';

export default {
  name: 'RegisterOk',
  mixins: [standardMix],
  components: {
  },
  data() {
    return {
      token: '',
      passwordRepeat: '',
      inputForm: {
        password: '',
        email: '',
      },
    };
  },
  methods: {
    async resetPassword() {
      if (this.inputForm.password !== this.passwordRepeat) {
        this.error('Passwords do not match');
      } else {
        try {
          this.busy();
          await userService.resetPassword(this.token, this.inputForm);
          this.success('Password reset complete');
          router.push({ name: 'Login' });
        // setTimeout(() => {
        //   router.push({ name: 'login' });
        // }, 1000);
        } catch (error) {
          this.error(error);
        }
      }
    },
  },
  created() {
    this.token = this.$route.query.token;
    if (!this.token) {
      router.push({ name: 'home' });
    }
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/ResetPassword.vue